import { Tooltip, TooltipContent, TooltipTrigger } from "src/components/ui/tooltip.component";
import { TooltipProvider } from "src/components/ui/tooltip.component";
import { Button, Modal } from "src/components";
import { switchString } from "src/utils/utils";
import moment from "moment";
import { useState } from "react";
import EInvoiceReject from "./E-InvoiceReject";
import { downloadInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { useNavigate } from "react-router-dom";
import EInvoiceAccept from "./E-InvoiceAccept";
import receipt from "src/features/fields/assets/receipt.svg";
interface EInvoiceCardProps {
  item: any;
  cardInfo: any;
  checkDataType: boolean;
  getEInvoicesData: () => void;
}

const EInvoiceCard = ({ item, checkDataType, cardInfo, getEInvoicesData }: EInvoiceCardProps) => {
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const verifyStringType = function (input: string) {
    const date = new Date(input);
    const numberRegex = /^\d+$/;
    if (!isNaN(date.getTime()) && input.trim() !== "" && !numberRegex.test(input)) {
      return moment(input).format("DD MMM, YYYY");
    } else {
      return input;
    }
  };

  return (
    <div>
      <div className="rounded-xl border-2 shadow-sm border-gray-200 my-6 list-none">
        <header className={"flex justify-between w-full px-5 py-5"}>
          <div className="flex flex-col gap-x-2">
            <div className="flex items-center gap-x-2">
              <h1 className={"font-semibold text-[1.2rem] mr-4"}>{item?.einvoiceDtls?.[0]?.stockistInvoiceAttachment?.company_name}</h1>
              <h1
                className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
                style={{
                  backgroundColor:
                    item?.einvoiceDtls?.[0]?.einvoice_status == "accepted"
                      ? "#D3F6E4"
                      : item?.einvoiceDtls?.[0]?.einvoice_status == "pending"
                        ? "#FFF9ED"
                        : "#FEE9E8",
                  color:
                    item?.einvoiceDtls?.[0]?.einvoice_status == "accepted"
                      ? "#207A65"
                      : item?.einvoiceDtls?.[0]?.einvoice_status == "pending"
                        ? "#996B0F"
                        : "#8E1F0B",
                }}
              >
                {item?.einvoiceDtls?.[0]?.einvoice_status}
              </h1>
            </div>
          </div>
          <div className="flex justify-end gap-x-2">
            <Button
              className="font-normal text-white h-10 border rounded-lg border-[#8051FF] shadow-sm bg-[#8051FF]"
              onClick={() => {
                navigate(`/transactions/e-invoice/${item?.einvoiceDtls?.[0]?.einvoice_dtl_id}`);
                // dispatch(invoiceActions.setSelectedEInvoice(item));
              }}
            >
              View Details
            </Button>

            <Button className="font-normal h-10 border rounded-lg border-gray-300 shadow-sm bg-gray-200" onClick={() => setIsAcceptModalOpen(true)}>
              Accept
            </Button>
            <Button className="font-normal h-10 bg-gray-200 rounded-lg border border-gray-300 shadow-sm" onClick={() => setIsRejectModalOpen(true)}>
              Reject
            </Button>
          </div>
        </header>

        <div>
          <div className={"grid grid-cols-3 gap-x-10 px-5 py-5 mt-0 xl:grid-cols-3 gap-y-5 mb-5"}>
            {!!cardInfo &&
              Object.keys(cardInfo)?.length > 0 &&
              Object.entries(cardInfo)?.map(
                ([key, value]) =>
                  typeof value === "string" &&
                  value !== "" && (
                    <div key={key?.toString()} className={"grid grid-cols-2 place-self-center -space-y-1 text-sm w-full"}>
                      <p className="text-[#49484C] place-self-center mr-auto text-sm leading-[0.02rem] font-normal not-italic">
                        {switchString(key)}
                        {key === "Stockist" && <span className="text-red-500">*</span>} :
                      </p>

                      <div className="mr-auto">
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger>
                              {checkDataType && typeof value === "string" && key == "Date"
                                ? verifyStringType(value)?.length > 20
                                  ? verifyStringType(value).slice(0, 20) + "..."
                                  : verifyStringType(value)
                                : ""}
                              <p className="text-[#1B1A1F] text-sm text-left mr-auto">
                                {key !== "Stockist Invoice" && key !== "Ack. Copy" && key !== "Date" && value}
                              </p>
                              {key === "Stockist Invoice" && (
                                <Button
                                  className="font-normal h-8 w-full rounded-md border border-gray-300 shadow-sm"
                                  onClick={() => {
                                    if (!cardInfo?.["Stockist Invoice"]) {
                                      toast({ description: "Invoice not found", variant: "destructive" });
                                      return;
                                    }
                                    downloadInvoice(cardInfo?.["Stockist Invoice"]).then((res: any) => {
                                      if (res?.data?.success && res?.data?.data) {
                                        window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                                      } else {
                                        console.error("Failed to download the invoice.");
                                      }
                                    });
                                  }}
                                >
                                  <img src={receipt} className="w-5 h-5 mr-2" alt="receipt" />
                                  Seller Invoice
                                </Button>
                              )}
                              {key === "Ack. Copy" && (
                                <Button
                                  className="font-normal h-8 w-full rounded-md border border-gray-300 shadow-sm"
                                  onClick={() => {
                                    if (!cardInfo?.["Ack. Copy"]) {
                                      toast({ description: "Invoice not found", variant: "destructive" });
                                      return;
                                    }
                                    downloadInvoice(cardInfo?.["Ack. Copy"]).then((res: any) => {
                                      if (res?.data?.success && res?.data?.data) {
                                        window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                                      } else {
                                        console.error("Failed to download the invoice.");
                                      }
                                    });
                                  }}
                                >
                                  <img src={receipt} className="w-5 h-5 mr-2" alt="receipt" />
                                  Ack. Copy
                                </Button>
                              )}
                            </TooltipTrigger>
                            <TooltipContent>{<p className="text-[#1B1A1F] mr-auto">{value}</p>}</TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </div>
                    </div>
                  )
              )}
          </div>
        </div>
        <div className="space-y-[-50px]">
          <Modal isOpen={isAcceptModalOpen} onCloseModal={() => setIsAcceptModalOpen(false)} isHeader={false}>
            <EInvoiceAccept
              onSuccess={() => {
                getEInvoicesData();
              }}
              primary_key={item?.einvoiceDtls?.[0]?.stockistInvoiceAttachment?.stockist_invoice_attachment_id}
              einvoice_dtl_id={item?.einvoiceDtls?.[0]?.einvoice_dtl_id}
              onCloseModal={() => setIsAcceptModalOpen(false)}
            />
          </Modal>
          <Modal isOpen={isRejectModalOpen} onCloseModal={() => setIsRejectModalOpen(false)} isHeader={false}>
            <EInvoiceReject
              onSuccess={() => {
                getEInvoicesData();
              }}
              primary_key={item?.einvoiceDtls?.[0]?.stockistInvoiceAttachment?.stockist_invoice_attachment_id}
              einvoice_dtl_id={item?.einvoiceDtls?.[0]?.einvoice_dtl_id}
              onCloseModal={() => setIsRejectModalOpen(false)}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default EInvoiceCard;
